/**
 * Shared validation constants and regex patterns
 * Used across donation-elements, donation-checkout, and hosted-page
 */

/**
 * Name validation regex - supports international characters
 * Allows:
 * - Unicode letters (any language: José, 北京, etc.)
 * - Spaces
 * - Hyphens (for names like Jean-Pierre)
 * - Apostrophes (for names like O'Brien)
 *
 * Examples of valid names:
 * - "John Smith"
 * - "José García"
 * - "O'Brien"
 * - "Jean-Pierre"
 * - "北京"
 */
export const NAME_VALIDATION_REGEX = /^[\p{L}\s'-]+$/u;

/**
 * Basic email validation regex
 * Checks for format: text@text.text
 */
export const EMAIL_VALIDATION_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Payment processor transaction limits
 * STRIPE is Stripe's own hard per-charge limit (card-present, measured).
 * FINIX has no processor-wide cap here: each nonprofit's own limit comes from the
 * server (`maxTransactionAmount`) and binds as-is. FINIX_DEFAULT_MAX_TRANSACTION_AMOUNT
 * is used only when the server sends no usable value.
 */
export const FINIX_DEFAULT_MAX_TRANSACTION_AMOUNT = 18000.00; // Finix onboarding default per-charge limit

// Legacy Finix cap, applied when the server does NOT say its value is the processor's real limit
// (`maxTransactionAmountIsProcessorLimit` absent/false): before the backend change the server
// value was a stamped form setting, so the old fixed cap must keep protecting Finix forms.
export const FINIX_LEGACY_MAX_TRANSACTION_AMOUNT = 18999.99;

export const PAYMENT_PROCESSOR_LIMITS = {
  STRIPE: 999999.99,    // Stripe's hard per-charge limit
  FINIX: FINIX_DEFAULT_MAX_TRANSACTION_AMOUNT, // Fallback only; the server value is not capped by it
  DEFAULT: 1000.00      // Fallback if processor is unknown
};

/**
 * Minimum transaction amount for all payment processors
 */
export const MIN_TRANSACTION_AMOUNT = 1.00;
